export default __webpack_public_path__ + "static/icon-16-6-6450dfc9bb35572a3cd09e9c708dc98d.png";